import './ExpandCarat.scss';
import { CaretRightOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import React from 'react';
export const ExpandCarat = ({ className, expanded, onClick }) => {
    const buttonClassNames = classNames('expand-carat', className);
    return (React.createElement("div", { className: buttonClassNames, onClick: onClick },
        React.createElement(CaretRightOutlined, { rotate: expanded ? 90 : 0 })));
};
